var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.676,
    height: 16.632,
    viewBox: "0 0 23.676 16.632",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "unify_icon",
    d: "M1.9,25.582V23.065a3.119,3.119,0,0,1,.482-1.7,2.934,2.934,0,0,1,1.339-1.138,21.235,21.235,0,0,1,3.522-1.232,13.818,13.818,0,0,1,3.227-.375,13.65,13.65,0,0,1,3.214.375,21.416,21.416,0,0,1,3.509,1.232,3.015,3.015,0,0,1,1.353,1.138,3.057,3.057,0,0,1,.5,1.7v2.518Zm18.748,0V23.065a4.335,4.335,0,0,0-.857-2.772,6.273,6.273,0,0,0-2.25-1.754,26.561,26.561,0,0,1,3.482.629,12.273,12.273,0,0,1,2.652.951,4.145,4.145,0,0,1,1.393,1.259,2.936,2.936,0,0,1,.509,1.687v2.518Zm-10.178-8.6a3.853,3.853,0,0,1-4.017-4.017A3.853,3.853,0,0,1,10.471,8.95a3.853,3.853,0,0,1,4.017,4.017,3.853,3.853,0,0,1-4.017,4.017Zm9.642-4.017A3.853,3.853,0,0,1,16.1,16.985a5.989,5.989,0,0,1-.656-.04,2.833,2.833,0,0,1-.656-.147,4.4,4.4,0,0,0,.978-1.647,6.708,6.708,0,0,0,.335-2.183,6.234,6.234,0,0,0-.335-2.129,5.694,5.694,0,0,0-.978-1.7A5.652,5.652,0,0,1,15.439,9,4.514,4.514,0,0,1,16.1,8.95a3.853,3.853,0,0,1,4.017,4.017ZM3.507,23.975H17.434v-.911a1.532,1.532,0,0,0-.254-.83,1.4,1.4,0,0,0-.629-.562A18.085,18.085,0,0,0,13.31,20.52a12.951,12.951,0,0,0-2.839-.295,13.135,13.135,0,0,0-2.852.295,17.925,17.925,0,0,0-3.254,1.152,1.328,1.328,0,0,0-.616.562,1.593,1.593,0,0,0-.241.83Zm6.964-8.6a2.336,2.336,0,0,0,2.41-2.41,2.336,2.336,0,0,0-2.41-2.41,2.336,2.336,0,0,0-2.41,2.41,2.336,2.336,0,0,0,2.41,2.41ZM10.471,23.975ZM10.471,12.967Z",
    transform: "translate(-1.9 -8.95)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifyIcon);
export default __webpack_public_path__ + "static/media/unify_icon.829e60597edb61da3b8c9c4e3011f9f8.svg";
export { ForwardRef as ReactComponent };